import React from 'react'

export default function Splash() {
	return (
		<div className="splash" />
	)
}



// WEBPACK FOOTER //
// ./src/components/Splash.jsx